import {
  FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST,
  FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS,
  FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE,
  CREATE_NAGRA_MONITORING_OPERATION_REQUEST,
  CREATE_NAGRA_MONITORING_OPERATION_SUCCESS,
  CREATE_NAGRA_MONITORING_OPERATION_FAILURE,
  END_NAGRA_MONITORING_OPERATION_REQUEST,
  END_NAGRA_MONITORING_OPERATION_SUCCESS,
  END_NAGRA_MONITORING_OPERATION_FAILURE,
} from '../../actionTypes';
import * as api from '../../apiHelper';
import { arriveNotice } from '../../noticeActions';

// --- Reducer corresponding actions ---

export function fetchNagraMonitoringOperationsRequest() {
  return { type: FETCH_NAGRA_MONITORING_OPERATIONS_REQUEST };
}
export function fetchNagraMonitoringOperationsSuccess(operationsDoc) {
  return { type: FETCH_NAGRA_MONITORING_OPERATIONS_SUCCESS, payload: { operationsDoc } };
}
export function fetchNagraMonitoringOperationsFailure(error) {
  return { type: FETCH_NAGRA_MONITORING_OPERATIONS_FAILURE, payload: { error } };
}

export function createNagraMonitoringOperationRequest() {
  return { type: CREATE_NAGRA_MONITORING_OPERATION_REQUEST };
}
export function createNagraMonitoringOperationSuccess(operationsDoc) {
  return { type: CREATE_NAGRA_MONITORING_OPERATION_SUCCESS, payload: { operationsDoc } };
}
export function createNagraMonitoringOperationFailure(error) {
  return { type: CREATE_NAGRA_MONITORING_OPERATION_FAILURE, payload: { error } };
}

export function endNagraMonitoringOperationRequest(monitoringUuid) {
  return { type: END_NAGRA_MONITORING_OPERATION_REQUEST, payload: { monitoringUuid } };
}
export function endNagraMonitoringOperationSuccess(operationsDoc) {
  return { type: END_NAGRA_MONITORING_OPERATION_SUCCESS, payload: { operationsDoc } };
}
export function endNagraMonitoringOperationFailure(error) {
  return { type: END_NAGRA_MONITORING_OPERATION_FAILURE, payload: { error } };
}

// --- API functions ---

async function fetchNagraMonitoringOperationsApi(token, dispatch) {
  const response = await api.get({
    path: 'nagra/monitoring-operations',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function createNagraMonitoringOperationApi(token, body, dispatch) {
  const response = await api.post({
    path: 'nagra/monitoring-operations',
    version: 'gateway',
    body,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

async function endNagraMonitoringOperationApi(token, monitoringUuid, body, dispatch) {
  const response = await api.patch({
    path: `nagra/monitoring-operations/${monitoringUuid}/end`,
    version: 'gateway',
    body,
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return api.camelizeKeys(json);
}

// --- Public component actions ---

export function fetchNagraMonitoringOperations() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(fetchNagraMonitoringOperationsRequest());
      const result = await fetchNagraMonitoringOperationsApi(adminToken, dispatch);
      dispatch(fetchNagraMonitoringOperationsSuccess(result.data));
    } catch (e) {
      dispatch(fetchNagraMonitoringOperationsFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function createNagraMonitoringOperation(label) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(createNagraMonitoringOperationRequest());
      const body = label ? { label } : {};
      const result = await createNagraMonitoringOperationApi(adminToken, body, dispatch);
      dispatch(createNagraMonitoringOperationSuccess(result.data));
      dispatch(arriveNotice('Monitoring operation created successfully.', 'ok'));
    } catch (e) {
      dispatch(createNagraMonitoringOperationFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}

export function endNagraMonitoringOperation(monitoringUuid, crawlingEndTs) {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken } } = getState();
      dispatch(endNagraMonitoringOperationRequest(monitoringUuid));
      // eslint-disable-next-line camelcase
      const body = crawlingEndTs ? { crawling_end_ts: crawlingEndTs } : {};
      const result = await endNagraMonitoringOperationApi(adminToken, monitoringUuid, body, dispatch);
      dispatch(endNagraMonitoringOperationSuccess(result.data));
      dispatch(arriveNotice('Monitoring operation ended.', 'ok'));
    } catch (e) {
      dispatch(endNagraMonitoringOperationFailure(e.message));
      dispatch(arriveNotice(e.message));
    }
  };
}
